import { useState } from "react";
import api, { formatApiError } from "@/api";
import { useLang } from "@/i18n";
import { toast } from "sonner";

export default function RegisterCoach() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/coach/coaches", form);
      toast.success(t("register.success"));
      setForm({ name: "", email: "", password: "" });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md kc-card p-8" data-testid="register-coach-card">
        <div className="flex justify-center mb-6">
          <img src="/adtraining-full-t.png" alt="AD TRAINING PROGRAM" className="h-28 w-auto kc-logo-ondark" />
          <img src="/adtraining-full-onlight.png" alt="AD TRAINING PROGRAM" className="h-28 w-auto kc-logo-onlight" />
        </div>
        <h1 className="text-3xl font-black uppercase tracking-tight mb-6">{t("register.newCoach")}</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{t("register.name")}</label>
            <input data-testid="register-name-input" required value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} className="kc-input mt-1" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{t("login.email")}</label>
            <input data-testid="register-email-input" type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} className="kc-input mt-1" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{t("login.password")}</label>
            <input data-testid="register-password-input" type="password" required minLength={6} value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} className="kc-input mt-1" />
          </div>
          {error && <p data-testid="register-error" className="text-sm text-destructive">{error}</p>}
          <button data-testid="register-submit-button" type="submit" disabled={loading} className="kc-btn-primary w-full">
            {loading ? t("common.loading") : t("register.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
